/* eslint-disable react/no-array-index-key */
import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import withMemo from '../../decorators/withMemo'
import Button from '../Button'
import Link from '../Link'

import useStyles from './styles'


const StartNav = (props) => {
  const classes = useStyles(props)
  const { className, buttons, skipLinks } = props

  return (
    <nav className={cx(className, classes.container)}>
      {buttons && (
        <ul className={classes.list}>
          {buttons.map((button, index) => (
            <li
              key={`startNavItem-${index}`}
              className={classes.item}
            >
              <Button
                {...button}
                className={classes.button}
              />
            </li>
          ))}
        </ul>
      )}
      {skipLinks && (
        <ul className={classes.list}>
          {skipLinks.map((link, index) => (
            <li
              key={`startNavSkip-${index}`}
              className={classes.item}
            >
              <Link
                {...link}
                className={classes.skiplink}
              >
                {link.text}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  )
}

StartNav.propTypes = {
  className: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.object),
  skipLinks: PropTypes.arrayOf(PropTypes.object),
}

StartNav.defaultProps = {
  className: null,
  buttons: null,
  skipLinks: null,
}

export default withMemo()(StartNav)
